import { Component, EventListener, GondelBaseComponent } from '@gondel/core';
import {
	IValidatableInputComponent,
	ValidatableInputData,
} from '../../../../shared/utils/js/validatable-input.interface';

/**
 * input module implementation.
 * @author Srdan Turudic <srdan.turudic@merkle.com>
 */

enum Selectors {
	Input = '.js-a-input__input',
	Hint = '.a-input__hint',
}

enum States {
	Error = 'state-a-input--error',
}

enum AllowedInputTypes {
	Text = 'text',
	Mail = 'email',
}

@Component('Input')
export class Input extends GondelBaseComponent implements IValidatableInputComponent {
	private _input: HTMLInputElement = {} as HTMLInputElement;
	private _hint: string = "";

	public start() {
		this._input = this._ctx.querySelector(Selectors.Input) as HTMLInputElement;
		this._hint = this._ctx.querySelector(Selectors.Hint)?.innerHTML ?? '';
	}

	/**
	 * Handle keyup
	 * read: https://www.toptal.com/developers/keycode/for/tab
	 */
	@EventListener('keyup', Selectors.Input)
	public _onKeyPress(): void {
		if (this._input.value.trim() !== '') {
			this._isValid();
		}
	}

	/**
	 * Handle focuous
	 */
	@EventListener('focusout', Selectors.Input)
	public _onFocusOut(): void {
		this._isValid();
	}

	public getData(): ValidatableInputData {
		return new ValidatableInputData(this._input.name, this._input.value);
	}

	/**
	 * Handle validation
	 */
	public _isValid(): boolean {
		if (
			this._input.hasAttribute('required') ||
			(!this._input.hasAttribute('required') && this._input.type === AllowedInputTypes.Mail)
		) {
			if (this._isValidInput(this._input.type as AllowedInputTypes)) {
				this._ctx.classList.remove(States.Error);
				// reset hint if it was a be validation error shown
				(this._ctx.querySelector(Selectors.Hint) as HTMLSpanElement).innerHTML = this._hint;
			} else {
				this._ctx.classList.add(States.Error);
			}
		}

		return !this._ctx.classList.contains(States.Error);
	}

	private _isValidInput(type: AllowedInputTypes): boolean {
		switch (type) {
			case AllowedInputTypes.Text:
				// Allows all charactes. needs at least 1 and up to 50
				// TODO: check how many characters we want to check
				return /^.{1,50}$/.test(this._input.value);
			case AllowedInputTypes.Mail: {
				if (!this._input.required && this._input.value.trim() === '') {
					return true;
				}
				// TODO: check with backend for same regex patter
				/* eslint-disable-next-line no-useless-escape */
				return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this._input.value);
			}
			default:
				throw new Error('No valid input type used');
		}
	}

	public _showValidationErrorsByBe(data: any) {
		this._ctx.classList.add(States.Error);
		(this._ctx.querySelector(Selectors.Hint) as HTMLSpanElement).innerHTML = data.errors.join(' ');
	}
}
